module.exports = __webpack_public_path__ + "img/claro-mondrian-logo.b793f2d6.png";